module.exports = __webpack_public_path__ + "img/preben.4098c6ec.png";